<template>
  <router-view/>
</template>
<script>
import { obterIconeSite } from '@/util/imagem'
import ViaCEP from './util/viaCep'
export default {
  beforeMount () {
    this.alterarFavicon()
  },
  provide () {
    return {
      viaCep: new ViaCEP()
    }
  },
  methods: {
    alterarFavicon () {
      const elementoFavicon = document.querySelector("link[rel*='icon']")
      elementoFavicon.setAttribute('href', obterIconeSite())
    }
  }
}
</script>
